import React, {useState} from 'react';

import {Button, Checkbox, Dialogue, Icon, Modal, Text} from '@albert-io/atomic';
import {local} from 'lib/StorageUtil';

import {useAnnotationModeStore} from './AnnotationModeStore';
import {useIsSessionOnlyAnnotationModeAvailable} from './useIsSessionOnlyAnnotationModeAvailable';

export const SESSION_ONLY_NOTICE_DISMISSED_KEY = 'session-only-annotation-notice-dismissed';

const DONT_SHOW_AGAIN_CHECKBOX_ID = 'session-only-annotation-notice__dont-show-again';

/** Mount only where annotations are session-only; in assignments they persist and this would lie. */
export default function SessionOnlyAnnotationNotice() {
  const isAvailable = useIsSessionOnlyAnnotationModeAvailable();
  const isAnnotationModeOn = useAnnotationModeStore((state) => state.isAnnotationModeOn);

  const [isDismissed, setIsDismissed] = useState(
    () => local.get(SESSION_ONLY_NOTICE_DISMISSED_KEY, false) === true
  );
  const [isDontShowAgainChecked, setIsDontShowAgainChecked] = useState(false);

  if (!isAvailable || !isAnnotationModeOn || isDismissed) {
    return null;
  }

  const handleClose = () => {
    if (isDontShowAgainChecked) {
      local.set(SESSION_ONLY_NOTICE_DISMISSED_KEY, true);
    }
    setIsDismissed(true);
  };

  return (
    <Modal ariaLabel='Heads up!' handleClose={handleClose}>
      {() => (
        <Dialogue className='rounded-x2 max-w-[320px]' hideCloseBtn>
          <div className='gap-x5 flex w-full flex-col items-center'>
            <Icon icon='hand' className='fa-2x' iconStyle='light' />
            <div className='gap-x2 flex w-full flex-col items-center'>
              <Text as='h2' bold className='m-x0 text-center'>
                Heads up!
              </Text>
              <Text className='text-center'>
                Your highlights and notes will disappear if you refresh or leave this page.
              </Text>
            </div>
            <div className='gap-x2 flex w-full flex-col items-center'>
              <Button className='w-full' color='primary' onClick={handleClose} variant='solid'>
                Got it!
              </Button>
              <label
                className='gap-x1 flex cursor-pointer items-center'
                htmlFor={DONT_SHOW_AGAIN_CHECKBOX_ID}
              >
                <Checkbox
                  aria-hidden={false}
                  checked={isDontShowAgainChecked}
                  id={DONT_SHOW_AGAIN_CHECKBOX_ID}
                  onChange={() => setIsDontShowAgainChecked((checked) => !checked)}
                  size='s'
                />
                <Text size='s'>Don&apos;t show this again</Text>
              </label>
            </div>
          </div>
        </Dialogue>
      )}
    </Modal>
  );
}
